<template>
  <van-config-provider :theme-vars="themeVars">
    <van-nav-bar
      :title="title"
      :left-text="leftText"
      :left-arrow="!!leftArrow"
      :right-text="rightText"
      :right-arrow="!!rightArrow"
      @click-left="onClickLeft ? onClickLeft() : back()"
      :fixed
      placeholder
    >

      <template v-if="leftArrow" #left>
        <van-icon class="mr-[8px]" name="arrow-left" size="20" />
        <span class="text-[18px] font-[600]">{{ leftText }}</span>
      </template>

      <template v-if="rightArrow" #right>
        <van-icon class="ml-[8px]" name="arrow-right" size="20" />
        <span class="text-[18px] font-[600]">{{ rightText }}</span>
      </template>

    </van-nav-bar>
  </van-config-provider>
</template>

<script setup lang="ts">
const {bgColor} = defineProps<{
  title?: string
  leftText?: string
  leftArrow?: boolean
  rightText?: string
  rightArrow?: boolean
  bgColor?: string
  onClickLeft?: () => void
  fixed?: boolean
}>()

const router = useRouter()

const back = () => {
  if (history.length > 1) {
    router.back()
  } else {
    router.push("/home")
  }
}

const themeVars = reactive({
  'nav-bar-title-text-color': '#FFFFFF',
  'nav-bar-icon-color': '#FFFFFF',
  'nav-bar-background': bgColor || '#2C3235',
  'border-width': '0',
  'nav-bar-height': '52px'
})
</script>